import { processUrl } from '@leagueplatform/league-routes';
import { NodeTransform } from '@leagueplatform/masonry-engine';
import { createAsyncNode } from '@leagueplatform/masonry-api';
import {
  MasonryDeeplinkAction,
  MasonryShowModalAction,
} from '@leagueplatform/masonry-renderers';
import { extraQueryParamsToRecord } from './utils/extra-query-params-to-record';

/**
 * Transform deeplink URLs from default paths to configured module paths
 */
export const allTransforms: NodeTransform = (node) => {
  const { actions } = node;
  if (actions) {
    Object.keys(actions).forEach((key) => {
      if (actions[key].type === 'deeplink') {
        (actions[key] as MasonryDeeplinkAction).payload.url = processUrl(
          actions[key].payload.url,
        );
      } else if (actions[key].type === 'showModal') {
        const { payload } = actions[key] as MasonryShowModalAction;

        const initialQueryParams = payload.extraQueryParams
          ? extraQueryParamsToRecord(payload.extraQueryParams)
          : {};

        if (payload.prefetch) {
          const modalNode = createAsyncNode({
            id: payload.nodeId,
            initialQueryParams,
          });

          // eslint-disable-next-line no-param-reassign
          node.prefetchNodes = node.prefetchNodes || [];
          node.prefetchNodes.push(modalNode);
        }
      }
    });
  }

  return node;
};

export const nodeTransforms = [allTransforms];
